import React from "react";
import useStyles from "../common/Styles";
import { Grid, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import { decimalRoundHelper } from "../common/utils";

const AgricultureMetrics = () => {
  const classes = useStyles();
  const { agriculture_selected, district_water } =
    useSelector((state) => state.water_user);
  let metrics = [];
  if (Object.keys(district_water).length) {
    metrics = [
      {
        label: "Groundwater",
        value: `${decimalRoundHelper(
          district_water[agriculture_selected.name].groundwater,
          0
        ).toLocaleString("en-US")} acre-feet`,
      },
      {
        label: "Salt & Verde",
        value: `${decimalRoundHelper(
          district_water[agriculture_selected.name].salt_and_verde,
          0
        ).toLocaleString("en-US")} acre-feet`,
      },
      {
        label: "Reclaimed Water",
        value: `${decimalRoundHelper(
          district_water[agriculture_selected.name].reclaimed_water,
          0
        ).toLocaleString("en-US")} acre-feet`,
      },
      {
        label: "Agua Fria",
        value: `${decimalRoundHelper(
          district_water[agriculture_selected.name].agua_fria,
          0
        ).toLocaleString("en-US")} acre-feet`,
      },
      {
        label: "Gila",
        value: `${decimalRoundHelper(
          district_water[agriculture_selected.name].gila,
          0
        ).toLocaleString("en-US")} acre-feet`,
      },
      {
        label: "Santa Cruz",
        value: `${decimalRoundHelper(
          district_water[agriculture_selected.name].santa_cruz,
          0
        ).toLocaleString("en-US")} acre-feet`,
      },
    ];
  }

  let metricTitle = {};
  if (Object.keys(district_water).length) {
    metricTitle = {
      // label: `${agriculture_selected.name}: Reliance on Colorado River water to meet customer demands`,
      label: `${agriculture_selected.name} current use of Colorado River water`,
      value: `${decimalRoundHelper(
        district_water[agriculture_selected.name].colorado_river,
        0
      ).toLocaleString("en-US")} acre-feet`,
    };
  }

  return (
    <Grid item xs={12} className={classes.aboutBox}>
      <Typography
        variant="body2"
        component="p"
        className={classes.metricCaption}
      >
        {metricTitle.label}
      </Typography>
      <Typography variant="h6" component="div" className={classes.metricValue}>
        {metricTitle.value}
      </Typography>
      <Typography
        variant="body2"
        component="p"
        className={classes.metricCaption}
      >
        How the district uses all water supplies
      </Typography>
      {metrics.map((metric) => (
        <>
          <Typography
            variant="body2"
            component="p"
            className={classes.metricTitle}
          >
            {metric.label}
          </Typography>
          <Typography
            variant="h6"
            component="div"
            className={classes.metricValue}
          >
            {metric.value}
          </Typography>
        </>
      ))}
    </Grid>
  );
};

export default AgricultureMetrics;
